// Copyright 2026. WebPros International GmbH. All rights reserved.

export const FAILOVER_DOMAINS = {
    TABLE: 'failover-domains-table',
};

export const FAILOVER_DOMAIN = {
    IS_ACTIVE: 'is-active',
    DELETE: 'delete',
};
